export default __webpack_public_path__ + "static/media/ic_my_clients.510e079d.svg";